(() => {
  'use strict';

  const root = window.Shopify?.routes?.root || '/';

  
  const noshiKeys = [
    '熨斗',
    '熨斗の種類',
    'のしの掛け方',
    '名入れ'
  ];

  /**
   * カート取得
   */
  async function getCart() {
    const response = await fetch(`${root}cart.js`, {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('カート情報の取得に失敗しました。');
    }

    return response.json();
  }
  
  /**
   * cart/change.js
   */
  async function changeLine(lineKey, quantity, properties) {
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        properties: properties
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'カートの更新に失敗しました。'
      );
    }

    return data;
  }


  /**
   * 熨斗properties以外を維持
   */
  function removeNoshiProperties(properties) {
  const newProperties = {
    ...(properties || {})
  };

  delete newProperties['熨斗'];
  delete newProperties['熨斗の種類'];
  delete newProperties['のしの掛け方'];
  delete newProperties['名入れ'];

    return newProperties;
}


  /**
   * エラー表示
   */
  function showError(container, message) {
    const error = container.querySelector(
      '[data-noshi-error]'
    );

    if (!error) {
      return;
    }

    error.textContent = message;
    error.hidden = false;
  }


  function clearError(container) {
    const error = container.querySelector(
      '[data-noshi-error]'
    );

    if (!error) {
      return;
    }

    error.textContent = '';
    error.hidden = true;
  }


  /**
   * 「あり」の詳細表示
   */
  function toggleDetails(container, enabled) {
    const details = container.querySelector(
      '[data-noshi-details]'
    );

    if (!details) {
      return;
    }

    details.hidden = !enabled;
  }


  /**
   * 「なし」にしたとき
   * 入力内容をクリア
   */
  function clearFields(container) {
    const quantity = container.querySelector(
      '[data-noshi-field="quantity"]'
    );

    const type = container.querySelector(
      '[data-noshi-field="type"]'
    );

    const name = container.querySelector(
      '[data-noshi-field="name"]'
    );

    const method = container.querySelector(
      'input[data-noshi-field="method"][value="外のし"]'
    );

    /*
     * 熨斗なしなので数量は0にしたいところですが、
     * selectの選択肢に0が必要。
     */
    if (quantity) {
      quantity.value = '0';
    }

    if (type) {
      type.value = '';
    }

    if (name) {
      name.value = '';
    }

    if (method) {
      method.checked = true;
    }
  }


  /**
   * 入力値取得
   */
  function getValues(container) {
    const noshi = container.querySelector(
      'input[data-noshi-type]:checked'
    );

    const quantity = container.querySelector(
      '[data-noshi-field="quantity"]'
    );

    const type = container.querySelector(
      '[data-noshi-field="type"]'
    );

    const method = container.querySelector(
      'input[data-noshi-field="method"]:checked'
    );

    const name = container.querySelector(
      '[data-noshi-field="name"]'
    );

    return {
      noshi: noshi ? noshi.value : 'なし',
      quantity: quantity
        ? parseInt(quantity.value, 10) || 0
        : 0,
      type: type ? type.value : '',
      method: method ? method.value : '',
      name: name ? name.value.trim() : ''
    };
  }


  /**
   * 保存
   */
  async function saveNoshi(container) {
  if (container.dataset.updating === 'true') {
    return;
  }

  const lineKey = container.dataset.lineKey;

  if (!lineKey) {
    showError(
      container,
      '商品の情報を取得できませんでした。'
    );
    return;
  }

  const values = getValues(container);

  clearError(container);

  /*
   * -----------------------------------------
   * 熨斗ありの入力チェック
   * -----------------------------------------
   */
  if (values.noshi === 'あり') {

    if (values.quantity <= 0) {
      showError(
        container,
        '熨斗を付ける数量を指定してください。'
      );
      return;
    }

    if (!values.type) {
      showError(
        container,
        '熨斗の種類を選択してください。'
      );
      return;
    }
  }

  container.dataset.updating = 'true';
  container.classList.add('is-updating');

  const button = container.querySelector(
    '[data-noshi-save]'
  );

  if (button) {
    button.disabled = true;
    button.textContent = '保存中…';
  }

  try {

    /*
     * 最新のカートを取得
     */
    const cart = await getCart();

    const item = cart.items.find(
      (cartItem) => cartItem.key === lineKey
    );

    if (!item) {
      throw new Error(
        '対象の商品がカート内に見つかりませんでした。'
      );
    }


    /*
     * 既存propertiesを取得
     *
     * 熨斗関連だけを取り除き、
     * その他のpropertiesはそのまま保持する。
     */
    const baseProperties =
      removeNoshiProperties(item.properties);


    /*
     * =========================================
     * 熨斗なし
     * =========================================
     *
     * 「熨斗なし」にした場合は、
     * 熨斗関連propertyを完全に削除する。
     */
    if (values.noshi === 'なし') {

  await changeLine(
    item.key,
    0,
    {}
  );

  console.log('[noshi-cart] add:', {
  variantId: item.variant_id,
  quantity: item.quantity,
  properties: baseProperties
});

  const addResponse = await fetch(`${root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          id: item.variant_id,
          quantity: item.quantity,
          properties: baseProperties
        }
      ]
    })
  });

  const addData = await addResponse.json();

  if (!addResponse.ok) {
    throw new Error(
      addData.description ||
      addData.message ||
      '熨斗なし商品の追加に失敗しました。'
    );
  }

  window.location.reload();
  return;
}


    /*
     * =========================================
     * 熨斗あり
     * =========================================
     */

    const noshiProperties = {
      ...baseProperties,
      '熨斗': 'あり',
      '熨斗の種類': values.type,
      'のしの掛け方': values.method,
      '名入れ': values.name
    };


    const noshiQuantity = values.quantity;
    const normalQuantity =
      item.quantity - noshiQuantity;


    /*
     * =========================================
     * ケース1
     *
     * 全数量に熨斗を付ける
     *
     * 商品A × 3
     * ↓
     * 商品A × 3
     * 熨斗あり
     * =========================================
     */
    if (normalQuantity === 0) {

      await changeLine(
        item.key,
        item.quantity,
        noshiProperties
      );

      window.location.reload();
      return;
    }


    /*
     * =========================================
     * ケース2
     *
     * 一部だけ熨斗を付ける
     *
     * 商品A × 3
     * ↓
     * 商品A × 2
     * 商品A × 1（熨斗）
     * =========================================
     */

    await changeLine(
      item.key,
      normalQuantity,
      baseProperties
    );


    /*
     * 熨斗ありの商品を追加
     */
    const addResponse = await fetch(
      `${root}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: item.variant_id,
              quantity: noshiQuantity,
              properties: noshiProperties
            }
          ]
        })
      }
    );


    const addData = await addResponse.json();

    if (!addResponse.ok) {
      throw new Error(
        addData.description ||
        addData.message ||
        '熨斗商品の追加に失敗しました。'
      );
    }


    /*
     * 完了
     */
    window.location.reload();

  } catch (error) {

    console.error(
      '[noshi-cart]',
      error
    );

    showError(
      container,
      error.message ||
      '熨斗設定の保存に失敗しました。'
    );

    container.dataset.updating = 'false';
    container.classList.remove('is-updating');

    if (button) {
      button.disabled = false;
      button.textContent = '熨斗設定を保存';
    }
  }
}


  /**
   * 熨斗あり / なし
   */
  document.addEventListener(
    'change',
    (event) => {

      const container =
        event.target.closest('[data-noshi-item]');

      if (!container) {
        return;
      }

      /*
      * 熨斗設定内のchangeイベントを
      * Riseのカート数量変更処理へ伝播させない
      */
      event.stopPropagation();


      /*
      * 熨斗あり / なし
      */
      const radio = event.target.closest(
        'input[data-noshi-type]'
      );

      if (!radio) {
        return;
      }

      const enabled =
        radio.value === 'あり';

      toggleDetails(
        container,
        enabled
      );

      if (!enabled) {
        clearFields(container);
      }

    }
  );

  /**
   * 保存ボタン
   */
  document.addEventListener(
    'click',
    (event) => {

      const button = event.target.closest(
        '[data-noshi-save]'
      );

      if (!button) {
        return;
      }

      event.preventDefault();

      const container =
        button.closest('[data-noshi-item]');

      if (!container) {
        return;
      }

      saveNoshi(container);
    }
  );

})();